<template>
  <div class="contact">
    <ul>
      <li v-for="(item, index) in contactList" :key="index">
        <a href="" class="d-flex d-flex-aic d-flex-jc-c d-flex-fdc">
          <img :src="item.imgUrl" alt="" />
          {{ item.name }}
        </a>
        <div class="contact-div">
          <a href="" v-if="item.message.length > 0 && index != 2">{{
            item.message
          }}</a>
          <p v-if="index == 2">{{ item.message }}</p>
          <img
            v-if="item.messageUrl.length > 0"
            :src="item.messageUrl"
            alt=""
            class="w-100"
          />
        </div>
      </li>
    </ul>
  </div>
</template>

<script>
export default {
  data() {
    return {
      contactList: [
        {
          name: "在线咨询",
          imgUrl: require("@/assets/images/contact1.png"),
          message: "QQ:395580691",
          messageUrl: "",
        },
        {
          name: "电话咨询",
          imgUrl: require("@/assets/images/contact2.png"),
          message: "电话:020-34794382",
          messageUrl: "",
        },
        {
          name: "微信",
          imgUrl: require("@/assets/images/contact3.png"),
          message: "请加商务微信",
          messageUrl: require("@/assets/images/admin_wx.png"),
        },
        {
          name: "公众号",
          imgUrl: require("@/assets/images/contact4.png"),
          message: "",
          messageUrl: require("@/assets/images/gzh_qrcode.jpg"),
        },
      ],
    };
  },
};
</script>

<style lang="less" scoped>
.contact {
  position: fixed;
  right: 0;
  top: 50%;
  transform: translate(0, -50%);
  z-index: 100000;
  ul {
    li {
      width: 69px;
      height: 78px;
      text-align: center;
      background: #457df3;
      border-bottom: 1px solid #6896f3;
      position: relative;
      &:last-of-type {
        border-bottom: none;
      }
      a {
        width: 69px;
        height: 78px;
        font-size: 12px;
        color: #fff;
        img {
          margin-bottom: 6px;
        }
      }
      .contact-div {
        display: none;
        width: 200px;
        position: absolute;
        top: 0;
        right: 82px;
        line-height: 78px;
        text-align: center;
        background-color: #fff;
        border-radius: 5px;
        border: 1px solid #bfc1c3;
        a,
        p {
          font-weight: bold;
          font-size: 16px;
          color: #5b97ff;
        }
      }
      &:nth-of-type(3) {
        .contact-div p {
          line-height: 30px;
        }
      }
      &:hover {
        a {
          font-weight: bold;
        }
        .contact-div {
          display: block;
        }
      }
    }
  }
}
</style>
